import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
export default {
    name: 'Parents',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // Parents list — Admin (1), School owner (40), School admin (41).
        if (!this.requireUserType([1, 40, 41])) return;

        if (this.loginDetails.userType == 40 || this.loginDetails.userType == 41) {
            this.selectedSchool = this.getSchoolId();
        }

        this.GetInfo(this.pageNo);
        this.GetAllSchools();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',
            selectedSchool: '',
            selectedStatus: '',

            ScreenTitle: 'أولياء الأمور',
            ScreenTitleSingle: 'ولي أمر',
            ScreenTitleSingleAl: 'ولي الأمر',

            Info: [],
            Statistics: [],
            Schools: [],

            SelectedItem: '',
            ruleForm: {
                Id: null,
                UsersId: null,
                SchoolsId: '',
                FirstName: '',
                FatherName: '',
                SirName: '',
                Name: '',
                Phone: '',
                Descriptions: '',
            },

            suspendForm: {
                ParentId: '',
                Reason: ''
            },

            childrenForm: {
                ParentUserId: 0,
                StudentIds: []
            },
            childrenSearch: '',
            childrenSchoolFilter: '',
            AvailableStudents: [],

            // STU-001: view a parent's currently-linked children.
            ChildrenList: [],
            childrenBusy: false,

            addStep: 'phone',
            phoneLookup: { phone: '', busy: false, found: null },
        };
    },

    methods: {

        OpenAddDialog() {
            this.ClearForm(this.ruleForm);
            this.addStep = 'phone';
            this.phoneLookup = { phone: '', busy: false, found: null };
            this.childrenForm.StudentIds = [];
            this.AvailableStudents = [];
        },

        LookupParentByPhone() {
            const n = this.normalizePhone(this.phoneLookup.phone);
            if (!n) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم الهاتف غير صالح (مثال: 0911234567).');
                return;
            }
            this.phoneLookup.busy = true;
            this.$http.SearchParentByPhone(n)
                .then(res => {
                    this.phoneLookup.busy = false;
                    const d = res.data;
                    if (d && d.found) {
                        this.phoneLookup.found = d;
                        this.ruleForm.Id = d.id;
                        this.ruleForm.FirstName = d.firstName || '';
                        this.ruleForm.FatherName = d.fatherName || '';
                        this.ruleForm.SirName = d.sirName || '';
                        this.ruleForm.Name = d.name || '';
                        this.ruleForm.Phone = d.phone;
                        this.ruleForm.SchoolsId = d.schoolsId || this.getSchoolId();
                        this.childrenForm.ParentUserId = d.userId || d.id;
                    } else {
                        this.phoneLookup.found = null;
                        this.ruleForm.Id = 0;
                        this.ruleForm.Phone = n;
                        this.ruleForm.SchoolsId = this.getSchoolId();
                        this.childrenForm.ParentUserId = 0;
                    }
                    this.addStep = 'profile';
                    this.GetStudentsList();
                })
                .catch(() => {
                    this.phoneLookup.busy = false;
                    this.$helper.ShowMessage('error', 'خطأ', 'تعذّر البحث.');
                });
        },

        isStudentLinkable(student) {
            return (student.parentsCount || 0) < 2;
        },

        parentSlotLabel(student) {
            const c = student.parentsCount || 0;
            return c === 0 ? 'بلا ولي أمر' : c === 1 ? 'ولي أمر واحد' : 'مكتمل (2/2)';
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetParents(this.pageNo, this.pageSize, this.Search, this.selectedSchool, this.selectedStatus)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        GetAllSchools() {
            this.$http.GetAllSchools()
                .then(response => {
                    this.Schools = response.data.info;
                })
                .catch(() => {
                    this.Schools = [];
                });
        },

        submitForm() {
            const n = this.normalizePhone(this.ruleForm.Phone);
            if (!n) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم الهاتف غير صالح (مثال: 0911234567).');
                return;
            }
            this.ruleForm.Phone = n;

            if (!this.ruleForm.FirstName && !this.phoneLookup.found) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى إدخال اسم ولي الأمر.');
                return;
            }

            // Idempotent add — backend returns existing parent if phone matches.
            this.ruleForm.Id = Number(this.ruleForm.Id || 0);

            this.$blockUI.Start();
            this.$http.AddParents(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    const data = response.data || {};
                    const userId = data.userId || this.childrenForm.ParentUserId || 0;

                    // Link selected students to the (possibly new) parent.
                    if (this.childrenForm.StudentIds.length > 0 && userId) {
                        this.childrenForm.ParentUserId = userId;
                        this.submitAddChildren();
                    } else {
                        this.$helper.ShowMessage('success', 'عملية ناجحة',
                            data.isNewlyProvisioned ? 'تمت إضافة ولي أمر جديد' : 'تم تحديث ولي الأمر');
                    }

                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('Close');
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.UserId = item.userId;
            this.ruleForm.SchoolsId = item.schoolsId;
            this.ruleForm.FirstName = item.firstName;
            this.ruleForm.FatherName = item.fatherName;
            this.ruleForm.SirName = item.sirName;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Descriptions = item.descriptions;
            this.state = 1;
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.UserId = item.userId;
            this.ruleForm.SchoolsId = item.schoolsId;
            this.ruleForm.FirstName = item.firstName;
            this.ruleForm.FatherName = item.fatherName;
            this.ruleForm.SirName = item.sirName;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Descriptions = item.descriptions;
        },

        submitEditForm() {
            const form = document.getElementById('parentForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');
            this.ruleForm.Id = Number(this.ruleForm.Id);

            this.$blockUI.Start();
            this.$http.EditParents(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('Close');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', errorMsg);
                });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هـل انت متأكد من عملية الحذف؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteParents(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدث خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        OpenSuspendModal(item) {
            this.SelectedItem = item;
            this.suspendForm = {
                ParentId: item.id,
                Reason: ''
            };
        },

        submitSuspend() {
            const form = document.getElementById('suspendForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى إدخال سبب إيقاف الحساب');
                return;
            }

            form.classList.remove('was-validated');

            if (!this.suspendForm.Reason || this.suspendForm.Reason.trim() === '') {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى إدخال سبب إيقاف الحساب');
                return;
            }

            Swal.fire({
                title: 'هل أنت متأكد؟',
                text: "سيتم تعليق حساب ولي الأمر",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'نعم، قم بالتعليق',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.SuspendParent(this.suspendForm)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.$helper.DestroyElemntById('CloseSuspendModal');
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },

        CancelSuspend(Id) {
            Swal.fire({
                title: 'هل أنت متأكد؟',
                text: "سيتم إلغاء تعليق حساب ولي الأمر",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'نعم، قم بإلغاء التعليق',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.CancelSuspendParent(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },

        Back() {
            this.SelectedItem = '';
            this.state = 0;
            this.GetInfo(this.pageNo);
        },

        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },

        OpenAddChildrenModal(item) {
            this.SelectedItem = item;
            this.childrenForm.ParentUserId = item.userId || item.id;
            this.childrenForm.StudentIds = [];
            this.childrenSearch = '';
            this.childrenSchoolFilter = '';
            this.GetStudentsList();
        },

        // STU-001: load + display the parent's linked children. The endpoint joins
        // PassengersParents.ParentsId == User.Id, so pass the parent's User id
        // (same id OpenAddChildrenModal uses to add children).
        OpenChildrenModal(item) {
            this.SelectedItem = item;
            this.ChildrenList = [];
            this.childrenBusy = true;
            const parentUserId = item.userId || item.id;
            this.$http.GetParentChildren(parentUserId)
                .then(response => {
                    this.childrenBusy = false;
                    this.ChildrenList = (response.data && response.data.children) || [];
                })
                .catch((err) => {
                    this.childrenBusy = false;
                    this.ChildrenList = [];
                    let errorMsg = err.response && err.response.data ? err.response.data : 'تعذّر جلب الأبناء';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        GetStudentsList() {
            this.$http.GetStudentsForParent(1, 1000, this.childrenSearch, this.childrenSchoolFilter)
                .then(response => {
                    this.AvailableStudents = response.data.info || [];
                })
                .catch(() => {
                    this.AvailableStudents = [];
                });
        },

        submitAddChildren() {
            if (!this.childrenForm.StudentIds.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى تحديد طالب واحد على الأقل');
                return;
            }

            const body = {
                ParentUserId: Number(this.childrenForm.ParentUserId),
                StudentIds: this.childrenForm.StudentIds.map(x => Number(x))
            };

            this.$blockUI.Start();
            this.$http.AddParentChildren(body)
                .then(response => {
                    this.$blockUI.Stop();
                    this.$helper.DestroyElemntById('CloseAddChildren');
                    const data = response.data;
                    this.$helper.ShowMessage('success', 'عملية ناجحة',
                        `تمت إضافة ${data.addedCount} طالب${data.skippedCount > 0 ? ' (تم تجاهل ' + data.skippedCount + ' مرتبط مسبقاً)' : ''}`
                    );
                    // Refresh the student list so parent-slot labels/disabled
                    // state reflect the new links (BUG-14).
                    this.GetStudentsList();
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

    }
}
